function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "46",
  height: "46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_10383_3014)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.825 12.35H4.59a4.589 4.589 0 100 9.177h12.236a4.589 4.589 0 100-9.177z",
  fill: "#36C5F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.65 16.938V4.702a4.589 4.589 0 10-9.177 0v12.236a4.589 4.589 0 109.177 0z",
  fill: "#2EB67D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.062 33.764h12.236a4.589 4.589 0 100-9.178H29.062a4.589 4.589 0 100 9.178z",
  fill: "#ECB22E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.236 29.175v12.237a4.589 4.589 0 109.178 0V29.175a4.589 4.589 0 10-9.178 0z",
  fill: "#E01E5A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.825.113a4.589 4.589 0 100 9.178h4.589V4.7A4.589 4.589 0 0016.825.114z",
  fill: "#36C5F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.887 16.938a4.589 4.589 0 10-9.178 0v4.589h4.589a4.589 4.589 0 004.589-4.589z",
  fill: "#2EB67D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.062 46a4.589 4.589 0 100-9.177h-4.59v4.588a4.589 4.589 0 004.59 4.59z",
  fill: "#ECB22E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 29.175a4.589 4.589 0 109.177 0v-4.589H4.59A4.589 4.589 0 000 29.176z",
  fill: "#E01E5A"
})));